// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
// tslint:disable:max-line-length
import { registerIcons } from '@uifabric/styling/lib/index';
export function initializeIcons(baseUrl, options) {
    if (baseUrl === void 0) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-14\"",
            src: "url('" + baseUrl + "fabric-icons-14-cf85ed5b.woff') format('woff')",
        },
        icons: {
            'PublishCourse': '\uF699',
            'DictionaryRemove': '\uF69A',
            'UserRemove': '\uF69B',
            'UserEvent': '\uF69C',
            'Encryption': '\uF69D'
        }
    };
    registerIcons(subset, options);
}
//# sourceMappingURL=fabric-icons-14.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@uifabric/icons/lib-es2015/fabric-icons-14.js
// module id = 567
// module chunks = 0